import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-19 17:00:10
 * @LastEditTime: 2022-01-12 16:56:12
 * @LastEditors: wangshengqiang
 * @Description: 输入组件
 */
import React from 'react';
import { Input } from 'zarm';
import { fixInputBlur, fixInputFocus } from '@/utils/tool';
import FormItem from '@/baseComponents/FormItem';
import './index.less';
export default function RowInput(props) {
  const {
    attrs = {},
    clearable = false,
    inputType = 'text',
    maxLength,
    formKey,
    label,
    disabled,
    placeholder,
    isBenefitFactor,
    isPremiumFactor,
    defaultValue,
    validateTrigger = 'onChange',
    isRequired,
    rules = [{
      required: true,
      message: '请输入'
    }],
    remark = {}
  } = props;
  const {
    display = {}
  } = attrs;

  const _placeholder = placeholder || display.placeholder;

  const initialValue = defaultValue || (display.hasDefaultValue && display.defaultValue ? JSON.parse(display.defaultValue) : '');
  const finalRules = Array.isArray(rules) && rules.length > 0 ? rules.map(item => _objectSpread(_objectSpread({}, item), {}, {
    required: isRequired
  })) : [{
    required: isRequired,
    message: '请输入'
  }];
  const formItemProps = {
    label,
    remark,
    name: formKey,
    fieldOption: {
      rules: finalRules,
      isBenefitFactor,
      isPremiumFactor,
      validateTrigger,
      initialValue
    }
  };
  return /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps), /*#__PURE__*/React.createElement(Input, {
    className: inputType === 'number' ? 'input-number' : '',
    type: inputType,
    clearable: clearable,
    onBlur: fixInputBlur,
    onFocus: fixInputFocus,
    placeholder: _placeholder,
    maxLength: maxLength,
    disabled: disabled
  }));
}